/**
 * Transport layer types (HTTP and WebSocket)
 */

export interface RequestConfig {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  path: string;
  headers?: Record<string, string>;
  body?: any;
}

export interface Response {
  statusCode: number;
  body: any;
  headers: Headers;
  duration: number;
}

export enum ConnectionState {
  Disconnected = 'disconnected',
  Connecting = 'connecting',
  Connected = 'connected',
  Reconnecting = 'reconnecting',
}

export type MessageHandler = (data: Record<string, any>) => void | Promise<void>;
